/**
 * Hook que retorna as respostas openQuestion liberadas pelo mestre num slide
 * e reage a openQuestionRevealed / sessionSnapshot. PR-4.
 */

import { useEffect, useState } from 'react'

import { useAdapter } from '../../adapter'
import type { RevealedResponse } from '../../types/adapter'

export function useRevealedResponses(slideIndex: number): RevealedResponse[] {
  const adapter = useAdapter()
  const [revealed, setRevealed] = useState<RevealedResponse[]>(
    adapter.getRevealedResponses(slideIndex),
  )

  useEffect(() => {
    setRevealed(adapter.getRevealedResponses(slideIndex))
    const off = adapter.on('openQuestionRevealed', () => {
      // patch já aplicado no adapter — re-pega snapshot atual.
      setRevealed([...adapter.getRevealedResponses(slideIndex)])
    })
    const offSnap = adapter.on('sessionSnapshot', () => {
      setRevealed([...adapter.getRevealedResponses(slideIndex)])
    })
    return () => {
      off()
      offSnap()
    }
  }, [adapter, slideIndex])

  return revealed
}
